import {byId, byIdOrThrow} from './commons'

interface TooltipOptions {
  tooltipId: string
  inputId: string
  submitId: string
}

function getValue(opt: TooltipOptions, type: string): string {
  const input = byId<HTMLInputElement>(`${opt.tooltipId}-${type}`, 'input')
  return input.value
}

function getInt(opt: TooltipOptions, type: string, fallback: number): number {
  const value1 = getValue(opt, type)
  const value2 = parseInt(value1)
  if (isNaN(value2)) return fallback
  return value2
}

function setRequirement(opt: TooltipOptions, index: number, ok: boolean) {
  const element = byId(`${opt.tooltipId}_${index}`)
  if (ok) {
    element.setAttribute('data-ok', 'true')
  } else {
    element.removeAttribute('data-ok')
  }
}

function resetRequirements(opt: TooltipOptions) {
  for (let index = 1; index <= 7; index++) {
    setRequirement(opt, index, false)
  }
}

function hasChars(value: string, chars: string[]): boolean {
  for (let index = 0; index < chars.length; index++) {
    const char = chars[index]
    if (value.includes(char)) {
      return true
    }
  }
  return false
}

(function(exports) {

  function init(opt: TooltipOptions) {

    const input = byIdOrThrow<HTMLInputElement>(opt.inputId, 'input')
    const tooltip = byIdOrThrow(opt.tooltipId)
    const submit = byId<HTMLInputElement | HTMLButtonElement>(opt.submitId)

    const minLength = getInt(opt, 'min-length', 3)
    const maxLength = getInt(opt, 'max-length', 12)
    const minDigits = getInt(opt, 'min-digits', 1)
    const minLower = getInt(opt, 'min-lower', 1)
    const minUpper = getInt(opt, 'min-upper', 1)
    const specialChars = getValue(opt, 'special-chars').split('')

    function checkPassword() {
      let ok = 0

      resetRequirements(opt)

      // Min length
      if (input.value.length >= minLength) {
        setRequirement(opt, 1, true)
        ok++
      }

      // Max length
      if (input.value.length >= minLength && input.value.length <= maxLength) {
        setRequirement(opt, 2, true)
        ok++
      }

      // Digits
      let match = input.value.match(/\d/g)
      if (match && match.length >= minDigits) {
        setRequirement(opt, 3, true)
        ok++
      }

      // Lowercase
      match = input.value.match(/[a-z]/g)
      if (match && match.length >= minLower) {
        setRequirement(opt, 4, true)
        ok++
      }

      // Uppercase
      match = input.value.match(/[A-Z]/g)
      if (match && match.length >= minUpper) {
        setRequirement(opt, 5, true)
        ok++
      }

      // Longer
      const longer = input.value.length > minLength
      setRequirement(opt, 6, longer)

      // Special characters
      const special = hasChars(input.value, specialChars)
      setRequirement(opt, 7, special)

      let score = 1
      if (ok > 4) {
        score = 2
        if (special) {
          score = 4
        } else if (longer) {
          score = 3
        }
      }

      tooltip.setAttribute('data-strength', '' + score)
      if (submit) {
        submit.disabled = score < 2
      }
    }

    input.addEventListener('focus', checkPassword)
    input.addEventListener('blur', checkPassword)
    input.addEventListener('keyup', checkPassword)

    checkPassword()
  }

  const module = exports.password || {}
  exports.password = {
    ...module,
    tooltip: {
      init
    }
  }

})(window['nam'] || (window['nam'] = {}))